var React = require('react');

function IconCaretInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.493662 0.159869L0.163822 0.487433C0.0608132 0.590524 0.00406476 0.727678 0.00406477 0.874265C0.00406477 1.02077 0.0608132 1.15809 0.163822 1.26118L3.9006 4.99779L0.159676 8.73872C0.0566671 8.84165 -4.46322e-08 8.97897 -3.82282e-08 9.12547C-3.18243e-08 9.27198 0.0566672 9.40938 0.159676 9.51238L0.487484 9.84003C0.700656 10.0534 1.04789 10.0534 1.26107 9.84003L5.7311 5.38601C5.83403 5.28308 5.90655 5.14593 5.90655 4.99812L5.90655 4.99641C5.90655 4.84983 5.83395 4.71267 5.7311 4.60974L1.27318 0.159869C1.17025 0.0567789 1.02895 0.000193551 0.882446 3.0479e-05C0.735859 3.04854e-05 0.596508 0.0567789 0.493662 0.159869Z","fill":"#0D263B"}));
}

IconCaretInline.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none"};

module.exports = IconCaretInline;

IconCaretInline.default = IconCaretInline;
